import * as React from 'react';
import { Field, ErrorMessage } from 'formik';
import { Form, FormProps} from '../form/Form';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';

interface CustomerResetFormProps extends TranslationProps {
  captcha: any
}

class CustomerResetForm extends Form<CustomerResetFormProps & FormProps, Record<string, unknown>> {
  constructor(props: CustomerResetFormProps) {
    super(props);
  }

  protected handleValidate(oldValues: any, oldErrors: any, values: any): any {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      this.emitValidating(true, false);
      const errors: any = {};

      if (!values.email) {
        errors.email = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
        errors.email = this.props.textsContent?.['AUTH_ERROR_INVALID_EMAIL'] ?? 'Cette adresse e-mail est invalide';
      }

      if (!values.captcha) {
        errors.captcha = this.props.textsContent?.['AUTH_ERROR_REQUIRED'] ?? 'Ce champ est obligatoire';
      }

      this.emitResult(values, errors, resolve, reject);
    });
  }

  protected formRender(isSubmitting: boolean): any {
    if(!this.props.captcha) {
      return false;
    }

    return (
      <div>
        <div>
        <Field required placeholder={this.props.textsContent?.['AUTH_LOGIN_ADDRESS'] ?? 'Adresse e-mail'} type="email" name="email" className="inputStyle w100 form-control" />
        </div>
        <ErrorMessage name="email" component="div"  className="errorMessageReact" />

        <div className="text-left mt-3 d-flex align-items-center captchaContainer">
          <img className="mr-2 imgCaptcha  " src={`data:image/png;base64,${this.props.captcha}`}/>
        <Field required placeholder={this.props.textsContent?.['AUTH_RESET_PASSWORD_CAPTCHA_PLACEHOLDER'] ?? 'Captcha'} type="text" name="captcha" className="inputCaptcha inputStyle form-control"  />
        </div>
        <ErrorMessage name="captcha" component="div"  className="errorMessageReact" />
        {(this.props.internalSubmitBtn || false) &&
        <button type="submit" disabled={isSubmitting}>
          {this.props.textsContent?.['AUTH_RESET_PASSWORD_BTN_SUBMIT'] ?? 'Valider'}
        </button>
        }
      </div>
    );
  }
}

export default WithTranslation(CustomerResetForm, 'AUTH_TUNNEL', 'EXCEPTIONS');